import { useQuery } from '@tanstack/react-query';

import { Membership } from 'src/features/membership/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership/`;

type QueryFnType = typeof queryFn;
interface DTO extends ListDTO {
    parkingId: string;
    category?: string;
    owner?: string;
    owner_or_identifier_owner?: string;
    membership_type?: string;
}
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<Membership>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        staleTime: 1000 * 60 * 30,
        ...config,
    });

export { RESOURCE as LIST_MEMBERSHIPS_RESOURCE, useQueryHook as useListMemberships };
